$(document).ready(function () {
  
  var stack = [];
  var variantCounts = {};
  var productInclusionMap = {
    "39765347074144": true,
    "39765347106912": false
  };

  function updateCheckout() {

    var total = 0;
    var checkoutItems = [];
    var totalQty = 0;

    $.each(variantCounts, function (variantId, count) {
      if (productInclusionMap[variantId] === true) return;

      var item = stack.find(function (i) {
        return i.variantId === variantId;
      });

      if (item) {
        total += item.price * count;
        totalQty += count;
        checkoutItems.push(variantId + ':' + count);
      }
    });

    $.each(productInclusionMap, function (variantId, include) {
      if (include === true) {
        if (!variantCounts[variantId]) {
          variantCounts[variantId] = 1;

          var existsInStack = stack.some(function (item) {
            return item.variantId === variantId;
          });

          if (!existsInStack) {
            var fallbackTitle = "Product " + variantId;
            var fallbackPrice = 0;
            stack.push({ productTitle: fallbackTitle, variantId: variantId, price: fallbackPrice });
          }
        }

        checkoutItems.push(variantId + ':1');
      }
    });

    $("#sub-total").text("$" + total.toFixed(2));

    if (checkoutItems.length > 0) {
      const discountMap = {
        2: { code: 'SS10E02CRJ965RW5', pct: '10' },
        3: { code: 'SS15CPK1N7Q2SRGZ', pct: '15' }
      };
      if (totalQty >= 2) {
        const { code, pct } = discountMap[totalQty] || { code: 'SS20KBEYXYS06MJC', pct: '20' };
        discountCode = code;
        savepct = pct;
      }
      var stacktotal = total - (total * savepct / 100);
      var disctotal = total - stacktotal;
      $("#disc-total").text(totalQty + " items (" + savepct + "% OFF)");
      $("#save-total").text("- $" + disctotal.toFixed(2));
      $("#stack-total").text("$" + stacktotal.toFixed(2));

      var checkoutURL = "/cart/" + checkoutItems.join(',');
      if (discountCode) checkoutURL += "?discount=" + discountCode;

      $("#checkout-btn").attr("href", checkoutURL).show();

      if (totalQty == 0) {
        $('.row-stack').hide();
      }
      if (totalQty > 1) {
        $('.row-stack').show();
        $('#checkout-btn').text('Checkout').css('pointer-events','all');
      } else {
        $('#checkout-btn').text('Add Minimum of 2').css('pointer-events','none');
      }
    }
  }

  $(".li-product .btn").click(function () {
    var $this = $(this);
    var productTitle = $this.data("product");
    var variantTitle = $this.data("variant");
    var variantId = String($this.data("variant-id"));
    var includeProduct = productInclusionMap[variantId];
    if (includeProduct === false) {
      console.log("Product " + variantId + " is excluded.");
      return;
    }
  
    var price = parseFloat($this.data("price"));  
    var $image = $this.parents('.ibot').siblings('.itop').children('.img');  
    var $imageClone = $image.clone();  
    variantCounts[variantId] = (variantCounts[variantId] || 0) + 1;
  
    var existsInStack = false;
    for (var i = 0; i < stack.length; i++) {
      if (stack[i].variantId === variantId) {
        existsInStack = true;
        break;
      }
    }

  if (!existsInStack) {
    stack.push({ productTitle: productTitle, variantId: variantId, price: price });
  }

  var $box = $this.closest('.li-product');
  $box.css('border-color','#141414');

  var $itag = $box.find('.tagz');

  if ($itag.length) {
    $itag.text("Added (" + variantCounts[variantId] + ")");
  } else {
    $itag = $("<div class='tagz' data-variant-id='" + variantId + "'>Added (" + variantCounts[variantId] + ")</div>");
    $box.append($itag);
  }

  var $existingStackItem = $("#stack-items .stack-item[data-variant-id='" + variantId + "']");
    if ($existingStackItem.length === 0) {
      var stackItem = '<div class="card-ss" data-variant-id="' + variantId + '"><div class="itop"></div><div class="ibot ibot-ss"><h4 class="h4t">' + productTitle + '</h4><h4 class="h3t">' + variantTitle + '</h4><span class="striked">$' + price.toFixed(2) + '</span></div><img src="https://cdn.prod.website-files.com/5e29c211b7c9a8c5af738c09/66e1dfdd5314627c9b2fe17f_ex.svg" class="remove-stack" data-variant-id="' + variantId + '">';
      var $stackItem = $(stackItem);
      $stackItem.find('.itop').append($imageClone);  
      $("#stack-items").append($stackItem);
      $("#stack-items .card-ss.card-free").remove();
      var manualCard = '<div class="card-ss card-free"><div class="itop"><img src="https://rysesupps.com/cdn/shop/files/sportshaker_2_53d1f545-ee7b-4547-a180-2c0e2d82a71f_600x.png?v=1693849705" class="item-ss"></div><div class="ibot ibot-ss"><h4 class="h4t">RYSE x SportShaker (black)</h4><h4 class="h3t">FREE at checkout</h4></div></div>';
      $("#stack-items").append(manualCard);
    }  
    updateCheckout();
  });

  $(".arobtn").click(function () {
    $(this).toggleClass('aro0');
    $('.slide-stack').slideToggle();
  });

  $(document).on("click", ".remove-stack", function () {

    $(this).parents(".card-ss").remove();    
    var variantId = String($(this).data("variant-id"));
    
    if (variantCounts[variantId]) {
      variantCounts[variantId]--;
      if (variantCounts[variantId] === 0) {
        delete variantCounts[variantId];
        $(".tagz[data-variant-id='" + variantId + "']").remove();
        $(".stack-item[data-variant-id='" + variantId + "']").remove();
      } else {
        $(".tagz[data-variant-id='" + variantId + "']").text("Added (" + variantCounts[variantId] + ")");
      }
    }
    updateCheckout();
  });

  $(document).on("mouseenter", ".tagzzzzzzz", function () {
    $(this).text("Remove");
  });

  $(document).on("mouseleave", ".tagz", function () {
    var variantId = $(this).data("variant-id");
    var count = variantCounts[String(variantId)] || 0;
    $(this).text("Added (" + count + ")");
  });

  $(document).on("click", ".tagz", function () {
    // var variantId = String($(this).data("variant-id"));
    // delete variantCounts[variantId];
    // $(this).remove();
    // $(".stack-item[data-variant-id='" + variantId + "']").remove();
    // updateCheckout();
  });

  $("[data-target]").on("click", function (e) {
    e.preventDefault();
    var targetId = $(this).data("target");
    var $targetHeading = $("h2[id='" + targetId + "']");  
    if ($targetHeading.length) {
      var scrollTo = $targetHeading.offset().top - 190;
      $("html, body").animate({ scrollTop: scrollTo }, 600);
    }
  });
  
});